import { Collapse, Empty } from 'antd';
import { groupByDay, relativeDay, formatDate, formatTime } from './timelineUtils';

/*
 * Renders a Collapse of date groups. Each row inside a group is drawn with a
 * timeline dot + connector. `getTime` reads the row's timestamp and
 * `renderBody` renders the row-specific content (note text / activity html).
 */
export default function TimelineGroups({
  rows = [],
  getTime,
  getKey,
  renderBody,
  emptyText = 'Nothing here yet.',
}) {
  const groups = groupByDay(rows, getTime);

  if (!groups.length) {
    return (
      <div className="znx-an-empty">
        <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={emptyText} />
      </div>
    );
  }

  const items = groups.map((group, groupIndex) => ({
    key: String(groupIndex),
    label: relativeDay(group.date),
    children: group.items.map((row, rowIndex) => {
      const time = getTime(row);
      const last = rowIndex === group.items.length - 1;

      return (
        <div className="znx-an-item" key={getKey(row, rowIndex)}>
          <div className="znx-an-rail">
            <span className="znx-an-dot" />
            {!last && <span className="znx-an-line" />}
          </div>
          <div className="znx-an-content">
            <div className="znx-an-meta">
              <span className="znx-an-date">{formatDate(time)}</span>
              <span className="znx-an-time">{formatTime(time)}</span>
            </div>
            {renderBody(row)}
          </div>
        </div>
      );
    }),
  }));

  return (
    <Collapse
      className="znx-an-collapse"
      defaultActiveKey={['0']}
      ghost
      items={items}
    />
  );
}
